import type { DocumentNode } from 'graphql';

// The client preset of the GraphQL codegen adds the hash of the persisted
// document under __meta__, outside of the DocumentNode type.
export const getDocumentHash = (document: DocumentNode): string | undefined =>
  (document as { __meta__?: { hash?: string } }).__meta__?.hash;
